
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface HtmlContentIm {
  body: string;
  footer: string | null;
  targetFileName: string | null;
  pagesTranslation: string | null;
  ofPagesTranslation: string | null;
}

@Injectable({ providedIn: 'root' })
export class PdfGeneratorService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient) {
    const apiUrl = 'https://pdfgen.itbees.pl'
    this.baseUrl = `${apiUrl}/PdfDocument`;
  }
  post(htmlContent: HtmlContentIm): Observable<Blob> {
    return this.http.post<any>(this.baseUrl, htmlContent, { responseType: 'blob' as 'json'});
  }
}
